import React from 'react';
import { FaMoneyBillWave, FaDownload, FaCheckCircle } from 'react-icons/fa';
import { Button } from '../../../../../components/ui/Button/Button';
import CodigoCopiavel from '../CodigoCopiavel';
import { FormGroup, RadioGroup, RadioLabel, Radio, BoletoBox,
BoletoIcon, BoletoTitle, BoletoText, InfoMessage } from './styles';

const PagamentoForm = ({
  tipoPagamento,
  setTipoPagamento,
  boletoGerado,
  tituloData,
  loading,
  onGerarBoleto
}) => {
  return (
    <>
      <FormGroup>
        <label style={{ marginBottom: '0.5rem', display: 'block', fontWeight: 500 }}>
          Forma de pagamento *
        </label>
        <RadioGroup>
          <RadioLabel>
            <Radio
              type="radio"
              name="tipoPagamento"
              value="BOLETO"
              checked={tipoPagamento === 'BOLETO'}
              onChange={() => setTipoPagamento('BOLETO')}
              disabled={boletoGerado}
            />
            Boleto Bancário
          </RadioLabel>
          <RadioLabel>
            <Radio
              type="radio"
              name="tipoPagamento"
              value="PIX"
              checked={tipoPagamento === 'PIX'}
              onChange={() => setTipoPagamento('PIX')}
              disabled={boletoGerado}
            />
            PIX
          </RadioLabel>
        </RadioGroup>
      </FormGroup>

      {tipoPagamento && !boletoGerado && (
        <BoletoBox>
          <BoletoIcon><FaMoneyBillWave /></BoletoIcon>
          <BoletoTitle>
            {tipoPagamento === 'BOLETO' ? 'Boleto Bancário' : 'PIX'}
          </BoletoTitle>
          <BoletoText>
            {tipoPagamento === 'BOLETO'
              ? 'Gere o boleto para pagar em qualquer banco, casa lotérica ou app do seu banco.'
              : 'Gere o código para pagar via PIX Copia e Cola no app do seu banco.'}
          </BoletoText>
          <Button variant="primary" onClick={onGerarBoleto} disabled={loading} leftIcon={<FaDownload />}>
            {loading ? 'Gerando...' : tipoPagamento === 'BOLETO' ? 'Gerar Boleto' : 'Gerar Código PIX'}
          </Button>
        </BoletoBox>
      )}

      {boletoGerado && (
        <>
          <InfoMessage style={{ background: '#f0fdf4', color: '#166534' }}>
            <FaCheckCircle />
            {tipoPagamento === 'BOLETO' ? 'Boleto gerado com sucesso.' : 'Código PIX gerado com sucesso.'} Guarde as informações abaixo para efetuar o pagamento.
          </InfoMessage>

          {tipoPagamento === 'BOLETO' && (
            <CodigoCopiavel
              label="Linha digitável"
              valor={tituloData?.linhaDigitavel}
              linkHref={tituloData?.urlBoleto}
              linkLabel="Abrir boleto em PDF"
            />
          )}

          {tipoPagamento === 'PIX' && (
            <CodigoCopiavel label="PIX Copia e Cola" valor={tituloData?.pixCopiaECola} qrCode />
          )}
        </>
      )}
    </>
  );
};

export default PagamentoForm;
